var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppImage',{attrs:{"title":"Side Navigation Image","collection":"side-navigation-images","items":_vm.sideNavigationImages,"lines":0,"singleRecord":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }